var React = require('react');

function RadioAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 128H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zM224 424a8 8 0 0 1-8 8H104a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h112a8 8 0 0 1 8 8zm32-64a8 8 0 0 1-8 8H72a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h176a8 8 0 0 1 8 8zm112 104a80 80 0 1 1 80-80 80 80 0 0 1-80 80zm80-208H64v-64h384z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M511.4 27.05l-4.33-15.38A16 16 0 0 0 487.33.6L64 128h147.5l288.83-81.21a16 16 0 0 0 11.07-19.74zM64 256h384v-64H64zm304 48a80 80 0 1 0 80 80 80 80 0 0 0-80-80zm0 112a32 32 0 1 1 32-32 32 32 0 0 1-32 32z","className":"fa-primary","key":2})]);
}

RadioAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = RadioAlt;

RadioAlt.default = RadioAlt;
